import styled, { css } from 'styled-components'
import { fontSizes } from '../../../styles/theme'
import Button, { ButtonLink } from '../../system/forms/button'

export const SidebarButtonStyle = css`
  display: block;
  margin-bottom: ${props => props.theme.spacing.base300};

  font-size: ${fontSizes.size600};
  line-height: ${fontSizes.lineHeight600};
`

export const SidebarButtonLink = styled(ButtonLink)`
  ${SidebarButtonStyle}
`

export const SidebarButton = styled(Button)`
  ${SidebarButtonStyle}
`
